import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { Tv3PlatformModule } from '@tokeet/tv3-platform'
import { CloseAccountDialogService } from './dialogs/close-account-dialog/close-account-dialog.service'
import { CloseAccountDialogComponent } from './dialogs/close-account-dialog/close-account-dialog.component'
import { MatRadioModule } from '@angular/material/radio'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Tv3PlatformModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
  ],
  providers: [CloseAccountDialogService],
  exports: [CloseAccountDialogComponent],
  declarations: [CloseAccountDialogComponent],
})
export class AccountLibModule {}
